import { render, staticRenderFns } from "./AceEditor.vue?vue&type=template&id=2dc9a6ed&scoped=true&"
import script from "./AceEditor.vue?vue&type=script&lang=js&"
export * from "./AceEditor.vue?vue&type=script&lang=js&"
import style0 from "./AceEditor.vue?vue&type=style&index=0&id=2dc9a6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9a6ed",
  null
  
)

export default component.exports